export const AuctionSortType = {
  ENDING_SOONEST: 'ENDING_SOONEST',
  LATEST_ADDED: 'LATEST_ADDED',
};

export const AuctionSortTypeName = {
  ENDING_SOONEST: 'ending soonest',
  LATEST_ADDED: 'latest added',
};
